var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-container" }, [
    _c(
      "div",
      [
        _c(
          "el-form",
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.goodsRecvVoucherItemList,
                  border: "",
                  "tooltip-effect": "dark"
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    type: "selection",
                    width: "55",
                    selectable: _vm.selectable
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "title",
                    label: "商品名称",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "catName",
                    label: "分类",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    label: "品牌",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "model",
                    label: "型号",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "fixedSpec",
                    label: "规格",
                    width: "150",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _vm.useFor != "assetStockIn" &&
                _vm.assetTypes != null &&
                _vm.assetTypes.length > 0 &&
                _vm.assetTypes[0] != 2
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "tmpNo",
                        label: "系统编号",
                        width: "230",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.useFor != "assetStockIn" &&
                _vm.assetTypes != null &&
                _vm.assetTypes.length > 0 &&
                _vm.assetTypes[0] != 2
                  ? _c("el-table-column", {
                      attrs: {
                        align: "left",
                        prop: "vendorUkno",
                        label: "商品标识码",
                        width: "220",
                        "show-overflow-tooltip": ""
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    label: "已收货数量",
                    width: "90",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "exchgSumQuantity",
                    label: "已换货数量",
                    width: "90",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "returnSumQuantity",
                    label: "已退货数量",
                    width: "90",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "assetInQuantity",
                    label: "已入库数量",
                    width: "90",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "assetCheckedQuantity",
                    label: "已验收数量",
                    width: "90",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _vm.useFor == "check"
                  ? _c("el-table-column", {
                      attrs: {
                        align: "right",
                        prop: "checkedQuantity",
                        label: "本次验收数量",
                        width: "100",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-input", {
                                attrs: { type: "text", disabled: "" },
                                on: {
                                  change: function($event) {
                                    _vm.checkedQuantityChange(scope.row)
                                  }
                                },
                                model: {
                                  value: scope.row.checkedQuantity,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "checkedQuantity", $$v)
                                  },
                                  expression: "scope.row.checkedQuantity"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "unit",
                    label: "单位",
                    width: "80",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "batchNo",
                    label: "批次号",
                    width: "140",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "desc",
                    label: "描述",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "assetType",
                    label: "管理方式",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.assetTypeMap[rows.row.assetType]))
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "desc",
                    label: "禁用原因",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.selectable(scope.row) == false
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.selectableMsg(scope.row)))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b9e0e51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b9e0e51","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsRecvVoucherItemSelect.vue
// module id = 2652
// module chunks = 0